export * from './Loading';
try {
    // @ts-ignore
    Loading.displayName = "Loading";
    // @ts-ignore
    Loading.__docgenInfo = { "description": "", "displayName": "Loading", "props": { "small": { "defaultValue": null, "description": "", "name": "small", "required": false, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Loading/index.ts#Loading"] = { docgenInfo: Loading.__docgenInfo, name: "Loading", path: "src/components/Loading/index.ts#Loading" };
}
catch (__react_docgen_typescript_loader_error) { }